import { style, media } from 'typestyle'
export const flexsm = style(media({ maxWidth: 576 }, { display: 'flex' }))
